import { __rest } from "tslib";
import CheckOutlined from '@haier/icons/CheckOutlined';
import CloseOutlined from '@haier/icons/CloseOutlined';
import classNames from 'classnames';
import RcSteps from 'rc-steps';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import useBreakpoint from '../grid/hooks/useBreakpoint';
import Progress from '../progress';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import useLegacyItems from './useLegacyItems';
const Steps = (props) => {
    const { percent, size, className, direction, items, responsive = true, current = 0, children } = props, restProps = __rest(props, ["percent", "size", "className", "direction", "items", "responsive", "current", "children"]);
    useBuriedPoint('Steps');
    const { xs } = useBreakpoint(responsive);
    const { getPrefixCls, direction: rtlDirection } = React.useContext(ConfigContext);
    const getDirection = React.useCallback(() => (responsive && xs ? 'vertical' : direction), [xs, direction]);
    const prefixCls = getPrefixCls('steps', props.prefixCls);
    const iconPrefix = getPrefixCls('', props.iconPrefix);
    const mergedItems = useLegacyItems(items, children);
    const stepsClassName = classNames({
        [`${prefixCls}-rtl`]: rtlDirection === 'rtl',
        [`${prefixCls}-with-progress`]: percent !== undefined,
    }, className);
    const icons = {
        finish: React.createElement(CheckOutlined, { className: `${prefixCls}-finish-icon` }),
        error: React.createElement(CloseOutlined, { className: `${prefixCls}-error-icon` }),
    };
    const stepIconRender = ({ node, status, }) => {
        if (status === 'process' && percent !== undefined) {
            // currently it's hard-coded, since we can't easily read the actually width of icon
            const progressWidth = size === 'small' ? 32 : 40;
            // iconWithProgress
            return (React.createElement("div", { className: `${prefixCls}-progress-icon` },
                React.createElement(Progress, { type: "circle", percent: percent, width: progressWidth, strokeWidth: 4, format: () => null }),
                node));
        }
        return node;
    };
    return (React.createElement(RcSteps, Object.assign({ icons: icons }, restProps, { current: current, size: size, items: mergedItems, direction: getDirection(), stepIcon: stepIconRender, prefixCls: prefixCls, iconPrefix: iconPrefix, className: stepsClassName })));
};
Steps.Step = RcSteps.Step;
export default Steps;
